<template>
    <div class="container">
        <TrfHeader pageTitle="Cadastro de formulários"></TrfHeader>

        <TrfModal
            v-if="modalConfirmacaoVisivel"
            idModal="excluir-formulario"
            titulo="Excluir Formulário"
            btnSaveName="Confirmar"
            :isBtnLoading="isBtnLoading"
            @save="this.delete"
            @close="cancelPreDelete"
            >
            <p class="card-content:" v-html="this.textoModalExclusao"></p><br />
        </TrfModal>

        <div class="columns is-full-width">
            <div class="column is-narrow">
                <TrfButton
                    @click="navegarNovoFormulario"
                    nome="Novo formulário"
                    classCor="is-primary"
                    :temIcon="true"
                    classIcon="mdi-plus"
                    class="is-fullwidth"
                    id="btn-nova-tarefa"
                />
            </div>
            <div class="column"><!--Spacer--></div>
            <div class="column is-narrow is-align-self-flex-end">
                <button id="cadastro-form-btn-voltar" class="button has-text-primary is-rounded" v-e2e="'cadastro-formulario-btn-voltar'" @click="voltarPagina">
                    <span class="icon">
                        <i class="mdi mdi-chevron-left-circle"></i>
                    </span>
                    <span>Voltar</span>
                </button>
            </div>
        </div>
        <div class="is-relative">
            <TrfGlobalLoader v-if="statusTabela == 'is-loading'" v-e2e="'templates-loader'" type="overlay" />
            <TrfTable
                :data-config="dataSource"
                :data="templates"
                :isButtonMoreHidden="true"
                :showDropdownOptions="false"
                :showButtonsDefault="false"
                :isButtonsDisplayed="false"
                :dataStatus="statusTabela"
                :isSelectable="false"
                :paginacao="true"
                :quantidade-de-items="paginacao.total"
                :paginaSelecionada="paginacao.page"
                :limiteAtual="paginacao.limit"
                :nextPage="atualizarPagina"
                :nextLimit="atualizarLimite"
                @update:pagina="atualizarPagina"
                @update:limite="atualizarLimite"

                @table-fechou-dropdowns="(event) => fecharDropDown(event)"
            >
                <template #maisAcoes="{ item }">
                    <div class="dropdown is-right" :class="{'is-active': activeDropdown == item.id}">
                        <div class="dropdown-trigger" @click="() => clickMaisAcoes(item)">
                            <span class="icon is-small">
                                <i class="mdi mdi-dots-horizontal mdi-24px" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="dropdown-menu" role="menu">
                            <div class="dropdown-content is-pulled-right is-active">
                                <button
                                    class="dropdown-item button is-small"
                                    @click="(event) => visualizarFormulario(item.id)"
                                    type="button"
                                >
                                    <i class="mdi mdi-eye mdi-14px" aria-hidden="true"></i> Visualizar
                                </button>
                                <button
                                    class="dropdown-item button is-small"
                                    @click="(event) => editarFormulario(item.id)"
                                    type="button"
                                >
                                    <i class="mdi mdi-pencil mdi-14px" aria-hidden="true"></i> Editar
                                </button>
                                <button
                                    :class="showDelete() ? 'dropdown-item button is-small' : 'is-hidden'"
                                    @click="(event) => this.preDelete(item, event)"
                                    type="button"
                                    :disabled="item.padrao"
                                    :title="item.padrao ? 'Este formulário é padrão do sistema e não poderá ser excluído.' : ''"
                                >
                                    <i class="mdi mdi-delete mdi-14px" aria-hidden="true"></i> Excluir
                                </button>
                            </div>
                        </div>
                    </div>
                </template>
            </TrfTable>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { routerUtils } from '../../util/router.utils';
import { pessoaLogada } from "../../stateManagement/pessoaLogada.js";
import { toastUtils } from '../../util/toast.utils.js';
import { tipoFormularioEnum } from '../../enums/tipoFormularioEnum';
const RETURN_URL_ENUM = {
    'elegalize': '/elegalize',
    'econtador': 'https://econtador.interno.pack.alterdata.com.br/Principal/Home',
    'default': '/elegalize'
}

export default {
  name: "Formularios",
  components: {
    TrfGlobalLoader: defineAsyncComponent(() => import('../../components/GlobalLoader/index.vue')),
    TrfHeader: defineAsyncComponent(() => import('../../components/Header/index.vue')),
    TrfTable: defineAsyncComponent(() => import('../../components/Table/index.vue')),
    TrfButton: defineAsyncComponent(() => import('../../components/Button/index.vue')),
    TrfModal: defineAsyncComponent(() => import('../../components/Modal/index.vue'))
  },
  props: {

  },
  data() {
    return {
        activeDropdown: null,
        statusTabela: 'is-loading',
        dataSource: {
            columns: [
                {
                    name: 'nome',
                    label: 'Formulário',
                    style: 'width: 95%',
                },
                {
                    name: 'maisAcoes',
                    label: '',
                    style: 'width: 5%',
                    slot: true
                }
            ],
            itens: [],
            itensSelected: [],
            itensDisabled: [],
            select: async (item, event, index) => await this.editarFase(item, event, index),
            delete: async (item, event, index) => this.delete(item, event, index),
        },
        templates: [],
        paginacao: {
            page: 1,
            limit: 10,
            total: 0
        },
        modalConfirmacaoVisivel: false,
        textoModalExclusao: 'Deseja excluir?',
        isBtnLoading: false
    }
  },
  methods: {
    async importTemplateFormularioService() {
        const { templateFormularioService } = await import('../../service/template-formulario-service.js')
        return templateFormularioService
    },
    async adquirirListagemTemplates(recarregar) {
        if (recarregar) {
            paginacao.page = 1;
            paginacao.limit = 10;
        }
        try {
            this.statusTabela = 'is-loading'
            const templateFormularioService = await this.importTemplateFormularioService();
            const request = await templateFormularioService.listar({
                "sort[DESC]": "id", 
                pagina: this.paginacao.page, 
                limit: this.paginacao.limit,
                tipoFormulario: tipoFormularioEnum.PROCESSO_ELEGALIZE.id
            })
            this.templates = request.data;
            this.paginacao.total = parseInt(request.totalDeItens)
            this.statusTabela = this.setStatusTabela()
        } catch (e) {
            console.warn(e)
            this.statusTabela = 'is-error'
        }
    },
    setStatusTabela() {
        if (this.templates.length == 0) {
            return 'is-empty'
        } else {
            return ''
        }
    },
    navegarNovoFormulario() {
        routerUtils._carregarNovaRota('/formularios/novo')
    },
    voltarPagina() {
        const source = this.$route.query.source;
        let url = RETURN_URL_ENUM['default'];
        let isUrlExterna = false;
        if (!!RETURN_URL_ENUM[source]) {
            url = RETURN_URL_ENUM[source];
            isUrlExterna = url.includes('.') || url.includes('http') || url.includes('https') || url.includes('www')
        }
        if(!isUrlExterna) {
            routerUtils._carregarNovaRota(url);
            return
        }

        routerUtils._carregarUrl(url)
    },
    clickMaisAcoes(item) {
        this.activeDropdown = this.activeDropdown? null : item.id
    },
    visualizarFormulario(id) {
        routerUtils._carregarNovaRota(`/formularios/visualizar/${id}`)
        window.scrollTo(0, 0)
    },
    editarFormulario(id) {
        routerUtils._carregarNovaRota(`/formularios/edicao/${id}`)
        window.scrollTo(0, 0)
    },
    fecharDropDown(event) {
        this.activeDropdown = null
    },
    async atualizarPagina(page) {
        if (this.statusTabela == 'is-loading' || page == this.paginacao.page) return;

        this.paginacao.page = page;
        await this.adquirirListagemTemplates()
    },
    async atualizarLimite(limit) {
        if (this.statusTabela == 'is-loading' || limit == this.paginacao.limit) return;

        this.paginacao.limit = limit;
        await this.adquirirListagemTemplates()
    },
    showDelete() {
        return pessoaLogada.hasPermissao("Tarefas", "Visualizar")
            && pessoaLogada.hasPermissao("Tarefas", "Excluir");
    },
    preDelete(item, event) {
        this.textoModalExclusao = `Deseja excluir o formulário <strong>${item.nome}</strong>?`;
        this.fecharDropDown(event);
        this.preDeleted = item;
        this.modalConfirmacaoVisivel = true;
    },
    cancelPreDelete() {
        this.preDeleted = null;
        this.modalConfirmacaoVisivel = false;
    },
    async delete() {
      this.isBtnLoading = true;
      try {        
        const templateFormularioService = await this.importTemplateFormularioService();
        await templateFormularioService.delete(this.preDeleted);
        toastUtils.successToast('Formulário excluído com sucesso!');
      } catch {
        toastUtils.dangerToast('Ocorreu um erro ao excluir o formulário.');
      } finally {
        this.modalConfirmacaoVisivel = false;
        this.isBtnLoading = false;
        await this.adquirirListagemTemplates();
      }
    },
  },
  async mounted() {
    await this.adquirirListagemTemplates();
  }
}
</script>
<style>

.dropdown-content > button {
  border: none;
  font-size: 16px;
}

</style>
